export const getQueryParam = (
  queryParams: { [key: string]: string | string[] | undefined },
  param: string,
) => {
  const [firstQueryParam] = [queryParams[param]].flat();

  return firstQueryParam;
};

export const convertToSlug = (str: string) =>
  str
    ?.replaceAll(/[^\w\s()]/g, '-') // Replace non-word characters except parentheses and spaces with hyphens
    .replaceAll(/[()]/g, '') // Remove parentheses entirely
    .replaceAll(/\s+/g, '-') // Replace spaces with hyphens
    .replaceAll('--', '-') // Replace spaces with hyphens
    .toLowerCase();
